/**
 * 打印用面试时长：
 * 1) 若有 totalMinutes（分钟，可为小数），按分钟向上取整，最少 1 分钟；
 * 2) 否则用 startTime 或 createTime 与 endTime 的间隔（秒向上取整到分钟，最少 1 分钟）；
 * 3) 若无 endTime，用当前时间作为结束（进行中面试）。
 */
export function formatInterviewDurationForPrint(info) {
  if (!info || typeof info !== 'object') return '';

  const tm = Number(info.totalMinutes);
  if (Number.isFinite(tm) && tm > 0) {
    return `${Math.max(1, Math.ceil(tm))}分钟`;
  }

  const startStr = info.startTime || info.createTime;
  const endStr = info.endTime;
  if (!startStr) return '';

  const start = parseInterviewTime(startStr);
  if (!Number.isFinite(start) || isNaN(start)) return '';

  let end;
  if (endStr) {
    end = parseInterviewTime(endStr);
    if (!Number.isFinite(end) || isNaN(end)) return '';
  } else {
    end = Date.now();
  }

  let diffSec = Math.floor((end - start) / 1000);
  if (diffSec < 0) diffSec = 0;
  const minutes = Math.max(1, Math.ceil(diffSec / 60));
  return `${minutes}分钟`;
}

function parseInterviewTime(str) {
  if (str == null) return NaN;
  if (typeof str === 'number' && Number.isFinite(str)) return str;
  const s = String(str).trim();
  if (!s) return NaN;
  let t = new Date(s.replace(/-/g, '/')).getTime();
  if (Number.isFinite(t) && !isNaN(t)) return t;
  t = new Date(s).getTime();
  return Number.isFinite(t) && !isNaN(t) ? t : NaN;
}
